<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <div class="lr between">
          <div style="display: flex;justify-content: flex-start;">
            <el-date-picker
              v-model="months"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              value-format="yyyy-MM"
              @change="search(true)">
            </el-date-picker>
          </div>
        </div>
        <div class="main" style="margin-top: 20px;">
          <el-table :data="table.data" height="600px" border
                    :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="tableLoading">
            <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                             align="center"/>
            <el-table-column show-overflow-tooltip label="小区" align="center"
                             prop="communityName"></el-table-column>
            <el-table-column show-overflow-tooltip label="房源" align="center"
                             prop="houseName"></el-table-column>
            <el-table-column show-overflow-tooltip label="付款方式" align="center"
                             prop="payType">
              <template slot-scope="scope">
                <span v-if="scope.row.payType == 0">月付</span>
                <span v-if="scope.row.payType == 1">季付</span>
                <span v-if="scope.row.payType == 2">半年付</span>
                <span v-if="scope.row.payType == 3">年付</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="押金" align="center"
                             prop="deposit"></el-table-column>
            <el-table-column show-overflow-tooltip label="租金" align="center"
                             prop="rent"></el-table-column>
            <el-table-column show-overflow-tooltip label="开始日期" align="center"
                             prop="startDate"></el-table-column>
            <el-table-column show-overflow-tooltip label="结束日期" align="center"
                             prop="endDate"></el-table-column>
            <el-table-column show-overflow-tooltip label="首次交租日期" align="center"
                             prop="firstRentDate"></el-table-column>
<!--            <el-table-column show-overflow-tooltip label="合同日期" align="center"-->
<!--                             prop="contractDate"></el-table-column>-->
            <el-table-column show-overflow-tooltip label="备注" align="center"
                             prop="description"></el-table-column>
<!--            <el-table-column show-overflow-tooltip label="操作" width="160" align="center">-->
<!--              <template slot-scope="scope">-->
<!--                <el-button type="text" @click="open(scope.row.id)">续租</el-button>-->
<!--              </template>-->
<!--            </el-table-column>-->
          </el-table>
        </div>
        <div class="lr end" style="margin-top: 20px;">
          <el-pagination :total="table.total" :page-size="table.query.size" :current-page="table.query.page"
                         layout="total, prev, pager, next" @current-change="currentPageChange"/>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="keepDialog.visible" :close-on-click-modal="false" width="40%" append-to-body
               title="续签">
      <el-form ref="keepForm" label-position="right" label-width="120px" :model="keepDialog.formData"
               :rules="rules">
        <el-form-item label="开始日期：" prop="startTime">
          <el-date-picker
            v-model="keepDialog.formData.startTime"
            type="date"
            placeholder="请选择开始日期"
            value-format="yyyy-MM-dd"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期：" prop="endTime">
          <el-date-picker
            v-model="keepDialog.formData.endTime"
            type="date"
            placeholder="请选择结束日期"
            value-format="yyyy-MM-dd"
            style="width: 100%;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="租金：" prop="price">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%" v-model="keepDialog.formData.price"
                           clearable/>
        </el-form-item>
      </el-form>
      <div class="dialog-btn">
        <el-button @click="keepDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="keepSign" :loading="loading">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import {getPageList} from "@/api/ownerRentRecord";
import {keepSign} from "@/api/collectRecord";

export default {
  props: {
    houses: {
      type:Array,
      default: () => []
    },
    houseId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      table: {
        query: {
          page: 1,
          size: 10,
          keyWord: '',
          contractDate: ''
        },
        total: 0,
        data: []
      },
      tableLoading: false,
      months: [],
      loading: false,
      keepDialog: {
        formData: {
          startTime: '',
          endTime: '',
          price: '',
          id: ''
        },
        visible: false
      },
      rules: {
        startTime: [{required: true, message: '请输入开始日期', trigger: 'blur'}],
        endTime: [{required: true, message: '请输入结束日期', trigger: 'blur'}],
        price: [{required: true, message: '请输入租金', trigger: 'blur'}]
      }
    }
  },
  mounted() {
    this.search(true)
  },
  methods: {
    // 搜索框查询
    search(flag) {
      this.tableLoading = true
      if (flag) {
        this.table.query.page = 1
        this.table.query.keyWord = ''
      }
      const params = {
        current: this.table.query.page,
        size: this.table.query.size,
        keyWord: this.table.query.keyWord,
        advent: true,
        withOutEnd: true
      }
      if (this.months && this.months.length > 0) {
        params.startMonth = this.months[0]
        params.endMonth = this.months[1]
      } else {
        params.startMonth = ''
        params.endMonth = ''
      }
      getPageList(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.table.data = response.data
          this.table.total = response.count
        } else {
          // 查询失败
          this.$message.error('查询失败!')
        }
        this.tableLoading = false
      })
    },
    // 页码变更
    currentPageChange(page) {
      this.table.query.page = page
      this.search(false)
    },
    open(id) {
      this.keepDialog.formData.id = id
      this.keepDialog.visible = true
      this.$nextTick(() => {
        this.$refs.keepForm.clearValidate()
      })
    },
    keepSign() {
      this.$refs['keepForm'].validate(async (valid) => {
        this.$confirm('确认续租, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const params = {
            type: 1,
            id: this.keepDialog.formData.id,
            startTime: new Date(this.keepDialog.formData.startTime).getTime(),
            price: this.keepDialog.formData.price
          }
          keepSign(params).then(response => {
            if (response.code == 200) {
              // 操作成功
              this.$message.success('操作成功!')
              this.search(false)
            } else {
              // 操作失败
              this.$message.error(response.data)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/RenewalOwnerRentRecord.vue